import $ from 'jquery'

export default () => {

    const $body = $('body')
    const $header = $('.header')
    const $openSearch = $('.js-open-search')
    const $openSearchFilters = $('.js-open-search-filters');
    const $searchFilters = $('.js-search-filters');
    const $navAccount = $('.nav-account')
    const $searchBox = $('.header__search-box')
    const $searchOverlay = $('.js-search-overlay');
    const $searchFilterButton = $('.js-search-filter-button');
    const $searchFilterInput = $('.js-search-filter-input');
    const $searchFilterCount = $('.js-search-filter-count');
    const $searchFilterSubmit = $('.js-search-filter-submit');
    const $headerSearch = $('.header__search')
    const $headerSearchInput = $('.js-search-header__form__input')
    const $toggleActive = $('.js-toggle-active')
    const $removeActive = $('.js-remove-active')
    const $filterSelectPopup = $('.filter-select__popup')
    const $menuItem = $('.menu-item-has-children')
    const $menuSubItem = $('.nav__sub-item')
    const $openMobileNav = $('.js-open-mobile-nav')
    const $toggleBodyOverflow = $('.js-toggle-body-overflow')
    const $sidebarToggle = $('.js-sidebar-toggle')
    const $sidebar = $('.js-sidebar')
    const $flippedCard = $('.card--flippable')
    const menuItem = '.menu-item-has-children'
    const activeClass = 'is-active'

    function toggleSearchFilters() {
        updateSearchButtonFilterCounter();
        $searchFilters.toggleClass(activeClass)
        $openSearchFilters.toggleClass(activeClass)
        $searchOverlay.toggleClass(activeClass)
        $body.toggleClass('noscroll');
        if ($searchFilters.hasClass(activeClass)) {
            $openSearchFilters.attr('aria-label', 'Close search filters')
        } else {
            $openSearchFilters.attr('aria-label', 'Open search filters')
        }
    }

    function toggleSearch() {
        $headerSearch.toggleClass(activeClass)
        $searchBox.toggleClass(activeClass)
        if ($searchBox.hasClass(activeClass)) {
            removeMenu()
            removeNav();
            removeAccount();
            $headerSearchInput.focus()
            $openSearch.attr('aria-label', 'Close search bar')
        } else {
            $openSearch.attr('aria-label', 'Open search bar')
        }
    }

    function removeSearch() {
        $headerSearch.removeClass(activeClass)
        $searchBox.removeClass(activeClass)
    }

    function toggleAccount() {
        $navAccount.toggleClass(activeClass)

        toggleHeader($navAccount.hasClass(activeClass), 'account')
    }

    function removeAccount() {
        $navAccount.removeClass(activeClass)
        $header.removeClass('is-active--account')
    }

    function removeMenu() {
        $menuItem.removeClass(activeClass)
    }

    function removeChildMenu() {
        $menuSubItem.removeClass(activeClass)
    }

    function removeNav() {
        $('.nav').removeClass(activeClass)
        $openMobileNav.removeClass(activeClass)
        $header.removeClass(activeClass)
    }

    function toggleHeader(active, type) {
        if (active) {
            $header.addClass(activeClass + ' ' + activeClass + '--' + type)
        } else {
            $header.removeClass(activeClass)

            setTimeout(function () {
                $header.removeClass('is-active--account is-active--nav')
            }, 300)
        }
    }

    // Open navigation search
    $openSearch.click(function(e) {
        toggleSearch()
        e.preventDefault()
    })

    // Open search filters
    $openSearchFilters.click(function() {
        toggleSearchFilters();
    })

    // Update Search Submit Button with Filter Count
    function updateSearchButtonFilterCounter() {
        if ($searchFilterCount.length > 0) {
            const searchFilterCounts = $searchFilterCount.filter('.is-active');
            const totalItems = $('.js-search-filter-total').data('total-count');
            let count = searchFilterCounts.length > 0 ? 0 : totalItems;
            searchFilterCounts.each(filterCount => {
                count = count + parseInt(searchFilterCounts[filterCount].dataset.count);
            });
            let buttonText = `Show ${ count } result`;
            buttonText += count !== 1 ? 's' : '';
            $searchFilterSubmit.text(buttonText);
        }
    }

    // Listen for search filter button clicks
    $searchFilterButton.click(function(e) {
        e.target.parentNode.nextElementSibling.classList.toggle(activeClass);
        updateSearchButtonFilterCounter();
    })

    // Make filter buttons submit on click for desktop
    $searchFilterInput.click(function() {
        if ( $(window).width() > 1023 ) {
            $('.js-search-filter-form').submit();
        }
    })

    // Open my account sub navigation
    $('.js-toggle-my-account').click(function() {
        removeMenu()
        removeSearch()
        removeNav()
        toggleAccount()

    })

    $('.js-close-nav').click(function() {
        removeMenu()
    })

    // Open mobile navigation
    $openMobileNav.click(function(e) {
        removeMenu()
        removeAccount()
        $('.nav').toggleClass(activeClass)
        $openMobileNav.toggleClass(activeClass)
        toggleHeader($openMobileNav.hasClass(activeClass), 'nav')
        removeSearch();
        e.preventDefault()
    })

    $toggleBodyOverflow.click(function(e) {
        $('html, body').toggleClass('overflow-hidden')

        e.preventDefault()
    })

    // Toggle active class on ID
    $toggleActive.click(function (e) {
        const $this = $(this)
        const target = $this.attr('href')

        if ($this.hasClass(activeClass)) {
            $toggleActive.removeClass(activeClass)
            $(target).removeClass(activeClass)
        } else {
            $toggleActive.removeClass(activeClass)
            $filterSelectPopup.removeClass(activeClass)
            $this.addClass(activeClass)
            $(target).addClass(activeClass)
        }

        e.preventDefault()
    })

    // Toggle active class on ID
    $removeActive.click(function (e) {
        const $this = $(this)
        const target = $this.attr('href')

        $toggleActive.removeClass(activeClass)
        $(target).removeClass(activeClass)

        e.preventDefault()
    })

    $sidebarToggle.click(function (e) {
        $sidebar.toggleClass(activeClass)
        $('html, body').toggleClass('overflow-hidden')
        e.preventDefault()
    });

    $('.menu-item-has-children .js-toggle-sub-nav').each(function() {
        const $this = $(this)
        $this.on('click', function(e) {

            if ( $(window).width() < 1200 ) {
                if($this.closest(menuItem).hasClass(activeClass)) {
                    $this.closest(menuItem).removeClass(activeClass)
                } else if($this.closest(menuItem).hasClass('nav__sub-item')) {
                    removeChildMenu()
                    $this.closest(menuItem).toggleClass(activeClass)
                } else {
                    removeMenu()
                    $this.closest(menuItem).toggleClass(activeClass)
                }
                e.preventDefault()
            } else  {
                $headerSearch.removeClass(activeClass)
                $searchBox.removeClass(activeClass)
                $navAccount.removeClass(activeClass)

                if($this.closest(menuItem).hasClass(activeClass)) {
                    $this.closest(menuItem).removeClass(activeClass)
                } else {
                    removeMenu()
                    $this.closest(menuItem).toggleClass(activeClass)
                }

                if($this.closest(menuItem).hasClass('nav__item')) {
                    e.preventDefault()
                }
            }
        })
    })

    $('.js-flip-card').each(function() {
        const $this = $(this)

        $this.on('click', function(e) {
            if($this.closest('.card').hasClass(activeClass)){
                $this.closest('.card').removeClass(activeClass)
            } else {
                $flippedCard.removeClass(activeClass)
                $this.closest('.card').addClass(activeClass)
            }

            e.preventDefault()
        })
    })

    /// Disable search button if nothing in the inputbox.
    $headerSearchInput.on('input', (event) => {
        const $eventTarget = $(event.target);
        const $formObj = $eventTarget.closest('.js-search-header__form');
        $formObj.find('.search-header__button').prop( "disabled", $eventTarget.val().length == 0 );
        $formObj.find('.js-search-icon-submit').prop( "style", $eventTarget.val().length == 0 ? 'display: none' : 'display: inherit' );
    })

    $('.js-search-icon-submit').click(function() {
        $('.js-search-header__form').submit();
    })


    // Section nav toggles
    // e.g. fleet management
    const $sectionNavBtn = $('.js-section-nav-btn')
    const $sectionNavBtnVehicle = $('.js-section-nav-btn-vehicle')
    const $sectionNavBtnAll = $('.js-section-nav-btn-all')
    const $vehicleRow = $('.js-row-toggle')
    const vehicleTypeOnload = window.location.hash.substr(1)
    let selectedVehicles = []

    $sectionNavBtn.click(function(e){
        const $this = $(this);
        const section = $this.data('section');

        if (section === 'all') {
            $sectionNavBtnVehicle.removeClass(activeClass)
            $this.toggleClass(activeClass)
            $vehicleRow.addClass(activeClass)
            selectedVehicles = []
        } else {
            $sectionNavBtnAll.removeClass(activeClass)
            $this.toggleClass(activeClass)

            //push to array or remove depending on toggle
            if($.inArray(section, selectedVehicles) !== -1) {
                selectedVehicles.splice( $.inArray(section, selectedVehicles), 1 );
            } else {
                selectedVehicles.push(section)
            }

            // if array is empty then show all
            // else check row against selectedVehicles array
            if (selectedVehicles.length === 0) {
                $vehicleRow.addClass(activeClass)
            } else {
                // show hide the row
                $vehicleRow.each(function() {
                    const $this = $(this)
                    const vehicles = $this.data('type')
                    const vehicleArray = vehicles.split(' ')

                    if(vehicleArray.some(r=> selectedVehicles.includes(r))) {
                        $this.addClass(activeClass)
                    } else {
                        $this.removeClass(activeClass)
                    }
                })
            }
        }

        e.preventDefault();
    });

    // This was somewhat of an afterthought and required a quick implementation
    // @todo refactor
    if(vehicleTypeOnload) {
        $('[data-section="' + vehicleTypeOnload + '"]').click()
    }

    // Section overlay toggle for mobile
    // e.g. fleet management
    const $overlayToggle = $('.js-toggle-section-nav')
    const $overlay = $('.js-overlay-nav')
    let windowScroll = 0

    $overlayToggle.click(function(e){
        $overlay.toggleClass(activeClass)
        $body.toggleClass(activeClass)

        if ($body.hasClass('is-ios')) {
            if ($body.hasClass(activeClass)) {
                windowScroll = window.pageYOffset

                setTimeout(function () {
                    window.scrollTo(0, 0)
                    $body.addClass('is-active--fixed')
                }, 300)
            } else {
                $body.removeClass('is-active--fixed')
                window.scrollTo(0, windowScroll)
            }
        }

        e.preventDefault();
    });

    // Social Share
    const shareLinks = [...document.querySelectorAll('.js-share-hyperlink')]
    
    shareLinks.forEach(sharelink => {
        sharelink.addEventListener('click', (e) => {
            e.preventDefault()

            const href = sharelink.getAttribute('href')
            const width = sharelink.dataset.width
            const height = sharelink.dataset.height

            window.open(href, 'share', 'width=' + width + ',height=' + height)
        })
    })
} 
